import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/angularjs';

import { BookingApiSettingsService } from './bookings.api-settings.service';
import { CompanyIntegrationsModel }  from '../companies/models/company.integrations';
import { CompanyService }            from '../companies/company.service';
import { ConfirmService }            from '../messages/confirm/confirm.service';
import { MessagesService }           from '../messages/messages.service';
import { SessionService }            from '../sessions/session.service';

@Component({
  selector   : 'wor-bookings-api-settings',
  template: require('./bookings.api-settings.component.html')
})
export class BookingsApiSettingsComponent {
  @Input() hideCancel  = false;
  @Input() integrations: CompanyIntegrationsModel;
  @Input() settings    : any;

  title : string = this.bookingApiSettingsService.title;

  constructor (
    private bookingApiSettingsService: BookingApiSettingsService,
    private companyService           : CompanyService,
    private confirmService           : ConfirmService,
    private messagesService          : MessagesService,
    private router                   : UIRouter,
    public  sessionService           : SessionService,
    private translateService         : TranslateService,
  ) {}

  activate () : void {
    if ( !this.companyService.isSubscriptionPlan('platinum') ) {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.PLATINUM_REQUIRED'), 'error');

      return;
    }

    this.bookingApiSettingsService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.bookingApiSettingsService.generateApiKey()
      .then(() => this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.NEW_API_KEY_GENERATED'), 'success'))
      .catch(error => this.messagesService.error(error))
      .finally(() => this.router.stateService.reload());
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.bookingApiSettingsService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  generateApiKey () : void {
    this.confirmService.generic(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE_NEW_KEY'), '', {
      cancelText : this.translateService.instant('GENERAL_SPACE.BUTTON.CANCEL'),
      confirmText: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE')
    })
    .then(() => this.bookingApiSettingsService.generateApiKey())
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.NEW_API_KEY_GENERATED'), 'success')
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.router.stateService.reload());
  }
}
